<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ffffff"
    >
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <circle cx="45" cy="45" r="30" />
        <rect x="86" y="29" rx="0" ry="0" width="60" height="28" />
        <rect x="159" y="32" rx="0" ry="0" width="57" height="19" />
        <rect x="16" y="95" rx="0" ry="0" width="340" height="56" />
        <rect x="16" y="170" rx="0" ry="0" width="20" height="20" />
        <rect x="45" y="170" rx="0" ry="0" width="76" height="20" />
        <rect x="291" y="32" rx="0" ry="0" width="57" height="19" />
        <rect x="17" y="216" rx="0" ry="0" width="20" height="20" />
        <rect x="46" y="216" rx="0" ry="0" width="76" height="20" />
        <rect x="18" y="258" rx="0" ry="0" width="20" height="20" />
        <rect x="47" y="258" rx="0" ry="0" width="76" height="20" />
        <rect x="19" y="303" rx="0" ry="0" width="20" height="20" />
        <rect x="48" y="303" rx="0" ry="0" width="76" height="20" />
        <rect x="20" y="343" rx="0" ry="0" width="20" height="20" />
        <rect x="49" y="343" rx="0" ry="0" width="76" height="20" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/mySkeleton.vue